import React from 'react'
import { SidebarContainer, Icon, CloseIcon,SidebarWrapper,SidebarMenu,SidebarDivider,SidebarLink} from './SidebarElements'

const Sidebar =({isOpen,toggle}) => {
    return (

        <SidebarContainer isOpen={isOpen}>
            <Icon onClick={toggle}>
                <CloseIcon/>
            </Icon>

            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to="/contact" onClick={toggle}>
                        Contact
                    </SidebarLink>
                    <SidebarDivider/>
                    <SidebarLink to="/questions" onClick={toggle}>
                        Questions?
                    </SidebarLink>
                    <SidebarDivider/>
                    <SidebarLink to="/legal" onClick={toggle}>
                        Legal
                    </SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
        
    )
}


export default Sidebar
